<template>
  <nk-page commercialAccess="Salary" class="job-field" policyClaims="Salary_JobField_Management">
    <template #badges>
      <nk-badge system="salary">
        <nk-badge-item type="system" modelValue="salary"></nk-badge-item>
        <nk-badge-item type="system" modelValue="salary" :title="$t('forms.JobField')"></nk-badge-item>
      </nk-badge>
    </template>
    <div class="nk-card h-100 d-flex flex-column" startup>
      <div class="h-grow-lock">
        <nk-table v-model="selectedRow" @data-changed="dataChanged" :data="jobFields" :options="tableOptions" ref="jobFieldList" tabindex="101" @row_dbClicked="rowDbClicked">
        </nk-table>
      </div>
    </div>
  </nk-page>
</template>
<script lang="ts">
  import Input from '~/components/general/nikan-input.vue'
  import $sc from '~/plugins/shortcut.collection.js'
  import dialog from '~/plugins/nikan-dialog-plugin'
  import validators from '~/statics/validators'
  import { defineComponent } from 'vue'
  import { JobField } from '~/classes/salary/job-field'
  import { post } from '~/plugins/nikan-api'
  import Endpoints from '@nikan/endpoints'
  import { IResponseList } from '@/interfaces/base'
  import IsEmpty from 'lodash/isEmpty'
  import { TYPE } from 'vue-toastification'

  export default defineComponent({
    name: 'job-field-selector',
    modal: {
      size: 'custom',
      width: 900,
      height: 600,
      stateUID: 'job-field-selector',
    },
    props: {
      options: { type: Object },
    },
    data() {
      return {
        jobFields: [] as JobField[],
        selectedRow: null as JobField | null,
        tableOptions: {
          activeRowDisabled: true,
          editable: this.$nikan.checkPermission({ or: ['Salary_JobField_Add', 'Salary_JobField_Delete'] }),
          searchable: false,
          allowNewRow: true,
          alwaysEmit: true,
          buttons: {
            addBtn: {
              options: {
                visible: true,
                policyClaims: 'Salary_JobField_Add',
              }
            },
            deleteBtn: {
              options: {
                visible: true,
                policyClaims: 'Salary_JobField_Delete',
              }
            }
          },
          displayOrderEnabled: false,
          prepareNewRow: () => new JobField(),
          columns: [
            {
              name: 'rowNumber',
              title: this.$t('row-number'),
              searchable: true,
              sortable: true,
              editable: false,
              width: 20,
              entering: false,
              pinned: true,
              pinnable: false,
              resizable: false,
            },
            {
              name: 'code',
              title: this.$t('salary.personnel.job-field.f.code'),
              edit: {
                component: Input,
                options: {
                  mode: 'string',
                },
              },
              searchable: true,
              sortable: true,
              editable: true,
              width: 40,
              entering: true,
              pinnable: true,
              validators: validators('required'),
            },
            {
              name: 'name',
              title: this.$t('salary.personnel.job-field.f.name'),
              edit: {
                component: Input,
                options: {
                  mode: 'string',
                },
              },
              searchable: true,
              sortable: false,
              editable: true,
              width: 150,
              validators: validators('required'),
            },
          ],
        },
        pageButtons: {
          saveButton: {
            title: this.$t('save'),
            shortcut: $sc.find('save'),
            icon: 'save',
            visible: true,
            disabled: true,
            isPrimary: true,
            handle: () => {
              this.save().then(() => {
                this.$nikan.formUtility.switchMode(this.pageButtons, 'select',)
                this.$refs.jobFieldList.table_Focused()
              })
            },
            policyClaims: { or: ['Salary_JobField_Add', 'Salary_JobField_Delete'] },
          },
          selectButton: {
            title: this.$t('select'),
            shortcut: $sc.find('save'),
            icon: 'check',
            isPrimary: true,
            visible: true,
            disabled: false,
            handle: () => {

              if (IsEmpty(this.selectedRow))
                return this.$toast(this.$t('document.m.select-row'))

              this.resolve(this.selectedRow)
            }
          }
        }
      }
    },
    mounted() {
      this.prepareWindow(this.$t('salary.personnel.job-field.title'), [this.pageButtons.selectButton, this.pageButtons.saveButton])
      this.loadJobFields()
    },
    methods: {
      save(): Promise<JobField[]> {
        return new Promise((resolve, reject) => {
          this.$refs.jobFieldList
            .commitChanges()
            .then((jobFields: (JobField & { rowState: string })[]) => {

              const wait = this.$wait(this.$el)
              post(Endpoints.getUrl('jobField.modify'), { items: jobFields })
                .then(() => {
                  this.$toast(this.$t('salary.personnel.job-field.m.save-success'), { type: TYPE.SUCCESS })
                  this.loadJobFields()
                  resolve(jobFields)
                })
                .finally(() => {
                  wait.end()
                })


            })
            .catch((errorRows: { message: string } | { rowNumber: number }[]) => {
              if (Array.isArray(errorRows)) {
                var rowNumbers = errorRows.map((x, i) => x.rowNumber).join(',')
                dialog({
                  title: this.$t('salary.personnel.job-field.m.save-codes-title'),
                  body: this.$t('salary.personnel.job-field.m.error-rows', { rowNumbers }),
                  type: 'error',
                  isPrimary: true,
                })
              } else {
                dialog({
                  title: this.$t('salary.personnel.job-field.m.save-codes-title'),
                  body: errorRows.message,
                  type: 'error',
                  isPrimary: true,
                })
              }

              reject(new Error('invalid-rows'))
              this.defer(() => this.$refs.jobFieldList.$el.focus(), 100)
            })
        })
      },
      dataChanged() {
        this.$nikan.formUtility.switchMode(this.pageButtons, 'edit')
      },
      rowDbClicked(val: JobField): void {
        if (this.grandParentType() === 'modal')
          this.resolve(val)
      },
      loadJobFields(): void {
        const wait = this.$wait(this.$el)
        post(Endpoints.getUrl('jobField.listDynamic'))
          .then((res: IResponseList<JobField>) => {
            this.jobFields = res.data.items
          })
          .finally(() => {
            wait.end()
          })
      }
    },
  })
</script>
<style></style>
